<div class="commands-table-container" *ngIf="commands && commands.length > 0; else emptyState">
  <table mat-table [dataSource]="commands" class="commands-table mat-elevation-z2">
    <!-- Command Column -->
    <ng-container matColumnDef="command">
      <th mat-header-cell *matHeaderCellDef>Command</th>
      <td mat-cell *matCellDef="let command">
        <code class="command-code">{{ '/' + command.command }}</code>
      </td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let command">
        <div class="command-description">
          <app-markdown [text]="command.description"></app-markdown>
        </div>
      </td>
    </ng-container>

    <!-- Usage Column -->
    <ng-container matColumnDef="usage">
      <th mat-header-cell *matHeaderCellDef>Usage</th>
      <td mat-cell *matCellDef="let command">
        <div class="command-usage">
          <div class="usage-text">{{ '/' + command.usage }}</div>
          <div class="usage-example">
            <strong>example: </strong>
            <code>{{ '/' + command.example }}</code>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Help Column -->
    <ng-container matColumnDef="help">
      <th mat-header-cell *matHeaderCellDef>Help</th>
      <td mat-cell *matCellDef="let command">
        <div class="command-help">
          <app-markdown [text]="command.help"></app-markdown>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let command; columns: displayedColumns;"></tr>
  </table>
</div>

<ng-template #emptyState>
  <div class="empty-state">
    <mat-icon class="empty-state-icon">info</mat-icon>
    <p class="empty-state-text">No commands found matching your filter.</p>
  </div>
</ng-template>
